import React from 'react'
import { type FormikProps } from 'formik'
import { type InjectedIntlProps } from 'intl/intl.types'
import { injectIntl } from 'react-intl'
import { trackEvent } from 'utils/events/trackEvent'
import {
  type ProductFormValues,
  type SecondaryImageAngles,
} from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import ProductImageUploader from './ProductImageUploader/ProductImageUploader'
import ProductTypeInfoModal from './ProductTypeInfoModal'

interface Props extends FormikProps<ProductFormValues>, InjectedIntlProps {
  required: boolean
  disabled?: boolean
}

const IMAGE_ANGLES: SecondaryImageAngles[] = [
  'angle_left',
  'angle_right',
  'angle_back',
  'angle_top',
  'ingredients',
  'nutrition',
  'supplements',
  'drugs',
  'lifestyle',
]

class SecondaryImages extends React.Component<Props> {
  handleChange(angle: SecondaryImageAngles, imageUrl: string | undefined): void {
    trackEvent({
      id: 'catalog.products.add_product.uploaded_secondary_image',
      description: 'Uploaded a secondary image',
    })
    this.props.setFieldValue(`secondary_images.${angle}`, imageUrl)
  }

  handleDelete(angle: SecondaryImageAngles): void {
    this.props.setFieldValue(`secondary_images.${angle}`, undefined)
  }

  render() {
    const { initialValues, values, required, disabled, errors, intl } = this.props
    const mountCollapsed = initialValues.primaryImageUrl === null

    return (
      <FormSection
        titleId="catalog.product.secondaryImages"
        renderAction={() => (disabled ? <ProductTypeInfoModal /> : null)}
        mountCollapsed={mountCollapsed}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            flexWrap: 'wrap',
          }}
        >
          {IMAGE_ANGLES.map((angle: SecondaryImageAngles) => {
            const imageUrl = values.secondary_images[angle]
            const error = errors.secondary_images && errors.secondary_images[angle]

            return (
              <div style={{ textAlign: 'center' }} key={angle}>
                <ProductImageUploader
                  required={required}
                  imageUrl={imageUrl}
                  onChange={url => this.handleChange(angle, url)}
                  onDelete={() => this.handleDelete(angle)}
                  disabled={disabled}
                  error={error}
                  label={intl.formatMessage({ id: `catalog.product.angle.${angle}` })}
                />
              </div>
            )
          })}
        </div>
      </FormSection>
    )
  }
}

export default injectIntl(SecondaryImages)
